import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Route } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { ToastContainer, Zoom } from 'react-toastify';
import Dropdown from '../../components/Dropdown';
import RegisterPage from '../RegisterPage';
import NoteEditPage from '../NoteEditPage';
import LoginPage from '../LoginPage';
import ForgotPage from '../ForgotPage';
import NotesPage from '../NotesPage';
import NotePage from '../NotePage';
import UploadFile from '../UploadFile';
import TemplateList from '../Template';
import AddEditTemplate from '../Template/AddEditTemplate';
import Search from '../Search';
import Navbar from './components/Navbar';
import Logo from './components/Logo';
import Content from './components/Content';
import { tokenSelector, emailSelector, pathnameSelector } from './reducer';
import { logout } from './actions';
import { getNotes } from '../NotesPage/actions';
import OtpVerifyPage from '../OtpVerifyPage';
import ResetPasswordPage from '../ResetPasswordPage';
import Settings from '../Settings/components/Settings';

class Main extends React.Component {
  state = {
    menuOpen: false,
  };

  componentDidMount() {
    const { getNotes, token, pathname, history } = this.props;
    if (token != null) getNotes();
    if (
      token == null &&
      !['/login', '/forgot', '/otp-verify', '/reset-password'].includes(
        pathname
      )
    ) {
      localStorage.removeItem('access_token');
      history.replace('/login');
    }
  }

  componentDidUpdate() {
    const { token, pathname, history } = this.props;
    if (
      token == null &&
      !['/login', '/forgot', '/otp-verify', '/reset-password'].includes(
        pathname
      )
    ) {
      localStorage.removeItem('access_token');
      history.replace('/login');
    }
    if (
      token != null &&
      [
        '/login',
        '/register',
        '/forgot',
        '/otp-verify',
        '/reset-password',
      ].includes(pathname)
    ) {
      history.replace('/');
    }
  }

  render() {
    const { token, email, logout, history, pathname } = this.props;
    const { menuOpen } = this.state;
    return (
      <React.Fragment>
        <Navbar>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              cursor: 'pointer',
            }}
            onClick={() => history.push('/')}
          >
            <img
              src="./favicon.ico"
              alt="VoiceboxMD Icon"
              style={{ width: '25px', marginBottom: '0' }}
            />
            <Logo src={require('../../assets/vb-logo.png')} />
          </div>
          {token && (
            <React.Fragment>
              {pathname === '/' && <Search className="ml-5 d-none d-sm-flex" />}
              <div className="ml-auto">
                <Dropdown
                  isOpen={menuOpen}
                  toggle={() => this.setState({ menuOpen: !menuOpen })}
                >
                  <Dropdown.Toggle caret>{email}</Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => history.push('/settings')}>
                      <FormattedMessage id="Main.settings" />
                    </Dropdown.Item>
                    <Dropdown.Item onClick={logout}>
                      <FormattedMessage id="Main.logout" />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </React.Fragment>
          )}
        </Navbar>
        <Content>
          <Route exact path="/" component={NotesPage} />
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/register" component={RegisterPage} />
          <Route exact path="/forgot" component={ForgotPage} />
          <Route exact path="/edit/:id?" component={NoteEditPage} />
          <Route exact path="/view/:id" component={NotePage} />
          <Route exact path="/uploadfile" component={UploadFile} />
          <Route exact path="/templates" component={TemplateList} />
          <Route
            exact
            path="/add-edit-template/:id"
            component={AddEditTemplate}
          />
          <Route exact path="/settings" component={Settings} />
          <Route exact path="/otp-verify" component={OtpVerifyPage} />
          <Route exact path="/reset-password" component={ResetPasswordPage} />
        </Content>
        <ToastContainer autoClose={2000} hideProgressBar transition={Zoom} />
      </React.Fragment>
    );
  }
}

Main = connect(
  createStructuredSelector({
    token: tokenSelector,
    email: emailSelector,
    pathname: pathnameSelector,
  }),
  { logout, getNotes }
)(Main);

export default Main;
